import { useState, useEffect, useRef } from "react";
import { validateNumberInput } from "../../utils";
import {
  CRYPTOURL,
  DEOSITBONUSURL,
  DEPOSITURL,
  UPI_PAYMENT
} from "../../DataStore/ApiConstant";
import axios from "axios";
import { BonusCalc } from "./BonusCalc";
import { CalculateTurnover } from "./turnOverCalc";
// import WhatsappButton from "../Cashier/whatsappButton";
import BonusOffer from "../TransactionCommon/BonusOffer";
import { TOAST_CONFIG } from "../../constants";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import _ from "lodash";
import { getFormData, calculateBonus, calculateTurnover } from "../../utils";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import { useWithdrawBonus } from "../../services/cashier";

import { useAtom } from "jotai";
import { bonusStore } from "../../DataStore/atom";


let validator = {
  // amount: yup
  //   .number()
  //   .required("Please provide amount.")
  //   .min(1, "Must be greater than 0")
  //   .typeError("Amount must be a number"),
}
const UpiPayment = ({ cashierReturnStatus, cashierReturnDepositPill }) => {

  const schema = yup.object().shape(validator);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [BonusStore, setBonusStore] = useAtom(bonusStore);
  const [vpaId, setVpaId] = useState(null);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const bonus = useWithdrawBonus();
  let [amount, setAmount] = useState(null);
  const [depositBonus, setDepositBonus] = useState(true);
  const [paymentErr, setPaymentErr] = useState(false);
  const [rdo, setRdo] = useState("upi");
  const [load, setLoad] = useState(false);
  const [reBonus, setReBonus] = useState(0);
  const [reTurn, setReTurn] = useState(0);
  const [selectedCurrency, setSelectedCurrency] = useState('USD');
  const [showSuccessMessage, setShowSuccessMessage] = useState(null);
  const statusMessageRef = useRef(null);

  const [rawAmount, setRawAmount] = useState(0);
  const [formattedAmount, setFormattedAmount] = useState("");
  const [selectedOption, setSelectedOption] = useState(1);

  const [upiIntentUrl, setUpiIntentUrl] = useState(null);


  const [showUPIFallback, setShowUPIFallback] = useState(false);


  // iOS detection
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  // Extract UPI params from upi://pay?....
  function getUPIParams(uri) {
    if (!uri) return '';
    const idx = uri.indexOf('pay?');
    if (idx === -1) return '';
    return uri.substring(idx + 4); // after 'pay'
  }

  // Build app-specific UPI URIs
  const upiParams = getUPIParams(upiIntentUrl || (typeof qrCodeUrl === 'string' && qrCodeUrl.startsWith('upi:') ? qrCodeUrl : ''));
  const phonepeUri = upiParams ? `phonepe://pay?${upiParams}` : '';
  const gpayUri = upiParams ? `gpay://upi/pay?${upiParams}` : '';
  const paytmUri = upiParams ? `paytmmp://pay?${upiParams}` : '';
  const defaultUri = upiIntentUrl || (typeof qrCodeUrl === 'string' && qrCodeUrl.startsWith('upi:') ? qrCodeUrl : '');

  const openAppUri = (uri) => {
    if (!uri) return;
    window.location.href = uri;
    setShowUPIFallback(false);
    setTimeout(() => {
      setShowUPIFallback(true);
    }, 2000);
  };

  const openUPIApp = () => {
    if (isIOS) return; // handled by buttons
    let intent = upiIntentUrl;
    if (!intent && typeof qrCodeUrl === 'string' && qrCodeUrl.startsWith('upi:')) {
      intent = qrCodeUrl;
    }
    if (!intent) return;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
      setShowUPIFallback(false);
      window.location.href = intent;
      setTimeout(() => {
        setShowUPIFallback(true);
      }, 2000);
    } else {
      window.location.href = intent;
    }
  };

  let submitHandler = async (upiObj) => {
    // Used by the /cashier/:status callback to reopen the correct inner tab.
    localStorage.setItem("cashierReturnDepositPill", "home");

    setLoad(true);
    // let url = `https://ballysbet.com/api/ipg/online-payment/visa-master-checkout?currency=${selectedCurrency}&amount=${amount}`
    // window.location.href=url;
    // console.log(amount);
    // setLoad(true);
    // let bonusAmt = 2;
    // let url = window.location.pathname;
    // depositBonus == null ? (bonusAmt = 2) : (bonusAmt = 1);
    // let conArr = { ...upiObj, url, bonus: bonusAmt, amount: amount };
    // axios
    //   .post(rdo == "upi" ? DEPOSITURL : CRYPTOURL, getFormData(conArr))
    //   .then((resp) => {
    //     if (resp?.data?.state == false) {
    //       setPaymentErr(resp.data.msg);
    //       // toast.error(resp?.data?.msg, TOAST_CONFIG);
    //       setLoad(false);
    //     }

    //     if (rdo == "upi") {
    //       resp.status && resp.data.data
    //         ? (window.location.href = resp.data.data)
    //         : setPaymentErr(resp.data.msg);
    //       setLoad(false);
    //     } else {
    //       resp.status && resp.data.data
    //         ? (window.location.href = `https://merchant.net-cents.com/widget/payment/currencies?data=${resp.data.data.token}`)
    //         : setPaymentErr(resp.data.msg);
    //       // toast.error(paymentErr, TOAST_CONFIG);
    //       setLoad(false);
    //     }
    //   })
    //   .catch((err) => {
    //     setPaymentErr(err);
    //     // toast.error("err", TOAST_CONFIG);
    //     setLoad(false);
    //   });
    // if (amount === null || amount === 0) {
    //   setPaymentErr("Please enter a valid amount");
    //   return;
    // }
    
    // let formData = new FormData();
    // formData.append("amount", amount);
    
    // axios
    //   .post(UPI_PAYMENT, formData, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   })
    //   .then((resp) => {
    //     if (resp.status === 200) {
    //       const redirectUrl = resp.data.data;
    //       window.location.href = redirectUrl;
          
    //       setLoad(false);
    //     }
    //   })
    //   .catch((err) => {
    //     setPaymentErr("An error occurred. Please try again.");
    //     setTimeout(() => {
    //       setPaymentErr("")
    //     }, 5000);
    //     setLoad(false);
    //   });      
    if (rawAmount === null || rawAmount === 0) {
      // alert(amount)
      setPaymentErr("Please enter a valid amount");
      setTimeout(() => {
        setPaymentErr("");
        }, 5000);
        setLoad(false);
      return;
    }
    // if (vpaId === null) {
    //   setPaymentErr("Please enter VPA ID");
    //   setTimeout(() => {
    //     setPaymentErr("");
    //     }, 5000);
    //     setLoad(false);
    //   return;
    // }
    let bonusstatus = 0;
    depositBonus == null ? (bonusstatus = 0) : (bonusstatus = 1);
    const formData = {"provider": "upi", "fiatAmount": String(rawAmount), "bonus": bonusstatus}
    
    axios
      .post(UPI_PAYMENT, formData, {
      })
      .then((resp) => {
        console.log(resp.data);
        if (resp?.data?.success) {
          if(resp?.data?.type == "qr"){
            // let qrCode = null;
            // let intentUrl = null;
            // Handle qr_code|URL:<url>
            // if (typeof resp.data.value === 'string' && resp.data.value.includes('|URL:')) {
            //   const [qrPart, urlPart] = resp.data.value.split('|URL:');
            //   qrCode = qrPart;
            //   intentUrl = urlPart;
            // } else {
            //   qrCode = resp.data.value;
            // }
            // setUpiIntentUrl(intentUrl);
            // If the value is a Blob, convert to base64 and set QR code
            // if (qrCode instanceof Blob) {
            //   const reader = new FileReader();
            //   reader.onloadend = () => {
            //     const base64Data = reader.result.split(',')[1];
            //     const qrCodeUrl = `data:image/png;base64,${base64Data}`;
            //     setQrCodeUrl(qrCodeUrl);
            //     setIsModalOpen(true);
            //     setRawAmount(0);
            //     setVpaId("");
            //     setFormattedAmount("");
            //     setLoad(false);
            //   };
            //   reader.readAsDataURL(qrCode);
            //   return;
            // } 
            // else {
            //   // If not a Blob, assume it's a URL or base64 string
            //   setQrCodeUrl(qrCode);
            //   setIsModalOpen(true);
            //   setRawAmount(0);
            //   setVpaId("");
            //   setFormattedAmount("");
            //   setLoad(false);
            //   return;
            // }
          } else{
            const redirectUrl = resp?.data?.value;
            window.location.href = redirectUrl;
            setRawAmount(0);
            setVpaId("");
            setFormattedAmount("");
            setLoad(false);
            return;
          }
          
          console.log(resp.data.value);
          
          const reader = new FileReader();

          // Define the onload event for the reader
          reader.onloadend = () => {
            // The result contains the data as a base64 encoded string
            const base64Data = reader.result.split(',')[1]; // Remove the data URL prefix
            const qrCodeUrl = `data:image/png;base64,${base64Data}`;
            

            // openGeneralModal("QRupi");
          };
        
          // Read the blob as a data URL
          // reader.readAsDataURL(blob);
          setLoad(false);
        }
        else{
          setPaymentErr("An error occurred. Please try again!");
          setVpaId("")
          setFormattedAmount("")
          setRawAmount(0)
          setTimeout(() => {
            setPaymentErr("");
            }, 5000);
          setLoad(false);
        }
      })
      .catch((err) => {
        setPaymentErr("An error occurred. Please try again.");
        setVpaId("")
        setFormattedAmount("")
        setRawAmount(0)
        setTimeout(() => {
          setPaymentErr("");
          }, 5000);
        setLoad(false);
      });     
  };

  const bonusOfferSwitch = async (status) => {

    setSelectedOption((prevOption) => (prevOption === status ? "" : status));
    setBonusStore(status);
    if (status) {
      axios
        .get(DEOSITBONUSURL)
        .then((resp) => {
          setDepositBonus(resp);
        })
        .catch((err) => {});
    } else {
      setDepositBonus(null);
    }
  };

  const formatCurrency = (value) => {
    const formattedValue = new Intl.NumberFormat("en-US", {
      // style: "currency",
      currency: "USD",
    }).format(value);
  
    return formattedValue;
  };

  const calculateBonuses = (reAmount) => {
    const numericValue = reAmount.replace(/[^0-9.]/g, "");
  
    setRawAmount(numericValue)
    // setAmount(reAmount);
    setFormattedAmount(numericValue ? formatCurrency(numericValue) : "");

    setAmount(reAmount);
    if (reAmount != "" && (reAmount < 5000 || reAmount > 100000)) {
      setPaymentErr("Please enter amount between min and max limit");
    } else {
      setPaymentErr(false);
    }

    if (bonus.data) {
      let bonusRet = calculateBonus(
        reAmount,
        bonus?.data[2]["maxbonus"] || 0,
        bonus?.data[2]["bonusprecent"] || 0
      );
      setReBonus(bonusRet);
      let turnRet = calculateTurnover(
        reAmount,
        bonus?.data[2]["maxbonus"] || 0,
        bonus?.data[2]["turnover"] || 0,
        bonus?.data[2]["bonusprecent"] || 0
      );
      setReTurn(turnRet);
    }
  };

  const handleCurrencyChange = (e) => {
    setSelectedCurrency(e.target.value);
  };

  const handleFocus = (event) => {
    event.target.select();
  };
  // useEffect(() => {
  //   bonusOfferSwitch(BonusStore);
  // }, [BonusStore]);
  useEffect(() => {
    if (cashierReturnDepositPill !== "home") return;
    if (cashierReturnStatus !== "upisuccess" && cashierReturnStatus !== "upifailed") return;

    setShowSuccessMessage(
      cashierReturnStatus === "upisuccess"
        ? "Your transaction was successful!"
        : "Your transaction failed!"
    );

    const timer = setTimeout(() => {
      setShowSuccessMessage(null);
      localStorage.removeItem("cashierReturnDepositPill");
    }, 5000);

    return () => clearTimeout(timer);
  }, [cashierReturnStatus, cashierReturnDepositPill]);

  useEffect(() => {
    if (!showSuccessMessage) return;

    const bannerEl = statusMessageRef.current;
    const fallbackPane = document.getElementById("v-pills-home");
    (bannerEl || fallbackPane)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [showSuccessMessage]);
  return (
    <div
      className="tab-pane fade "
      id="v-pills-home"
      role="tabpanel"
      aria-labelledby="v-pills-home-tab"
    >
      <div className="row">
        {/* Form starts here */}
        {/*
        // --- Previous code block (form and layout) ---
        <form onSubmit={handleSubmit(submitHandler)}>
          <div>
            <div className="row">
              ...previous form and layout code...
            </div>
          </div>
        </form>
        // --- End previous code block ---
        */}
        <form onSubmit={handleSubmit(submitHandler)}>
          <div>
            <div className="row d-flex justify-content-center my-5">
              <div className="col-md-4 mb-3">
                <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  <TranslatesContent contentKey="deposit-amount" />
                </label>
                <div className="input-group">
                  <span
                    className="input-group-text"
                    style={{ border: "1px solid #2f2f2f", fontWeight: 600, backgroundColor: "#c7c7c7" }}
                  >
                    INR
                  </span>
                  <input
                    type="text"
                    value={formattedAmount}
                    style={{ textAlign: "right" }}
                    className={`form-control ${_.isEmpty(errors) ? "" : errors?.amount ? "is-invalid" : "is-valid"}`}
                    placeholder="0"
                    onFocus={handleFocus}
                    onInput={(e) => { calculateBonuses(e.target.value); }}
                  />
                  <div className="col-12">
                    <div className="form-text text-center">
                      <TranslatesContent contentKey="min-max-limit" />: INR 5000 / INR 100,000
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-4 mb-3">
                <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  Sender VPA ID {" "}
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    value={vpaId}
                    style={{ textAlign: "right" }}
                    onChange={(e) => setVpaId(e.target.value)}
                    className={`form-control`}
                    placeholder="VPA ID"
                    onFocus={handleFocus}
                  />
                </div>
              </div> */}
            </div>
            <div className="row d-flex justify-content-center">
              <div className="col-md-3 mb-3">
                <div className="row">
                  <div className="col-12" style={{ textAlign: "center" }}>
                    <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                      Bonus Activation
                    </label>
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="px-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          style={{ padding: "0" }}
                          type="radio"
                          defaultValue=""
                          id="flexCheckDefault"
                          checked={selectedOption === 1}
                          onChange={() => bonusOfferSwitch(1)}
                        />
                        <label className="form-check-label mt-1 ms-2" htmlFor="flexCheckDefault">
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="px-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          style={{ padding: "0" }}
                          type="radio"
                          defaultValue=""
                          id="flexCheckChecked"
                          checked={selectedOption === 0}
                          onChange={() => bonusOfferSwitch(0)}
                        />
                        <label className="form-check-label mt-1 ms-2" htmlFor="flexCheckChecked">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex justify-content-center">
              <div className="col-md-6 mb-3">
                {errors?.amount?.message ? (
                  <div className="invalid-feedback">{errors?.amount?.message}</div>
                ) : null}
                {paymentErr && (
                  <div className="alert alert-danger" role="alert">{paymentErr}</div>
                )}
                <div>
                  {showSuccessMessage && (
                    <div
                      ref={statusMessageRef}
                      className={showSuccessMessage.includes("failed!") ? "success-message-error" : "success-message"}
                    >
                      {showSuccessMessage}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row d-flex justify-content-center">
              <div className="col-md-4 mb-3">
                <button type="submit" className="btn btn-primary btn-lg w-100" disabled={load}>
                  {load ? "Processing..." : "CONFIRM"}
                </button>
              </div>
            </div>
          </div>
        </form>
        {/* Form ends here */}
        {/* QR Code Modal */}
        {isModalOpen && qrCodeUrl && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              background: "rgba(0,0,0,0.5)",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 9999,
              alignItems: "center",
              justifyContent: "center",
            }}
            tabIndex="-1"
            aria-labelledby="upipayment"
            aria-modal="true"
            role="dialog"
          >
            <div className="modal-dialog" style={{ maxWidth: 370 }}>
              <div className="modal-content bg-white text-black" style={{ borderRadius: 12, minWidth: 0, width: 350, margin: '0 auto' }}>
                <div className="modal-header d-none d-lg-flex">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    style={{ position: "absolute", right: 15 }}
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  {/* Desktop View */}
                  <div className="d-none d-lg-block">
                    <div className="d-flex justify-content-center" style={{ fontSize: "2.2rem" }}>
                      <i className="fa-solid fa-desktop"></i>
                    </div>
                    <div className="qrpaymentTitel d-flex justify-content-center" style={{ fontSize: 18 }}>
                      Desktop users, <br /> please scan the QR Code with your mobile to complete your payment.
                    </div>
                    <div className="qrpaymentTitel d-flex justify-content-center" style={{ fontSize: 12 }}>
                      डेस्कटॉप उपयोगकर्ताओं, कृपया अपना भुगतान पूरा करने के लिए अपने मोबाइल से QR कोड स्कैन करें।
                    </div>
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <img src={qrCodeUrl} className="img-fluid" alt="QR Code" style={{ maxWidth: 180, maxHeight: 180 }} />
                    </div>
                    <div className="qrpaymentText d-flex justify-content-center mb-1" style={{ fontSize: 14 }}>
                      After making the payment, <br/> please press the CLOSE button.
                    </div>
                    <div className="qrpaymentText d-flex justify-content-center mb-1" style={{ fontSize: 11 }}>
                      भुगतान करने के बाद, कृपया CLOSE बटन दबाएँ।
                    </div>
                    <div className="d-flex justify-content-center">
                      <button type="button" className="btn btn-primary w-100" onClick={closeModal}>
                        CLOSE
                      </button>
                    </div>
                  </div>
                  {/* Mobile View */}
                  <div className="d-block d-lg-none">
                    {!showUPIFallback ? (
                      <>
                        <div className="d-flex justify-content-center" style={{ fontSize: "2.2rem" }}>
                          <i className="fa-solid fa-mobile-screen"></i>
                        </div>
                        <div className="qrpaymentTitel d-flex justify-content-center" style={{ fontSize: 18 }}>
                          Mobile Users, <br />please tap a UPI app below to complete your payment.
                        </div>
                        <div className="qrpaymentTitel d-flex justify-content-center" style={{ fontSize: 12 }}>
                          मोबाइल उपयोगकर्ता, कृपया अपना भुगतान पूरा करने के लिए नीचे किसी UPI ऐप पर टैप करें।
                        </div>
                        {isIOS ? (
                          <div className="d-flex flex-column gap-2 align-items-center my-3 w-100">
                            <button type="button" className="btn btn-primary w-100 mb-2 d-flex align-items-center justify-content-center" style={{ fontWeight: 600, height: 48, fontSize: 16, borderRadius: 6, gap: 8 }} onClick={() => openAppUri(phonepeUri)}>
                              <img src="https://storage.googleapis.com/itonecdn/logos/upi-providers/PhonePe-Logo.png" alt="PhonePe" style={{ width: 24, height: 24, marginRight: 6, background: '#fff', borderRadius: 4, display: 'inline-block' }} />
                              <span style={{ flex: 1, textAlign: 'center', display: 'inline-block' }}>Pay with PhonePe</span>
                            </button>
                            <button type="button" className="btn btn-primary w-100 mb-2 d-flex align-items-center justify-content-center" style={{ fontWeight: 600, height: 48, fontSize: 16, borderRadius: 6, gap: 8 }} onClick={() => openAppUri(gpayUri)}>
                              <img src="https://storage.googleapis.com/itonecdn/logos/upi-providers/Google_Pay-Logo.png" alt="Google Pay" style={{ width: 24, height: 24, marginRight: 6, background: '#fff', borderRadius: 4, display: 'inline-block' }} />
                              <span style={{ flex: 1, textAlign: 'center', display: 'inline-block' }}>Pay with Google Pay</span>
                            </button>
                            <button type="button" className="btn btn-primary w-100 mb-2 d-flex align-items-center justify-content-center" style={{ fontWeight: 600, height: 48, fontSize: 16, borderRadius: 6, gap: 8 }} onClick={() => openAppUri(paytmUri)}>
                              <img src="https://storage.googleapis.com/itonecdn/logos/upi-providers/Paytm-Logo.png" alt="Paytm" style={{ width: 24, height: 24, marginRight: 6, background: '#fff', borderRadius: 4, display: 'inline-block' }} />
                              <span style={{ flex: 1, textAlign: 'center', display: 'inline-block' }}>Pay with Paytm</span>
                            </button>
                            <button type="button" className="btn btn-primary w-100 d-flex align-items-center justify-content-center" style={{ fontWeight: 600, height: 48, fontSize: 16, borderRadius: 6 }} onClick={() => openAppUri(defaultUri)}>
                              <span style={{ flex: 1, textAlign: 'center', display: 'inline-block' }}>Pay with UPI App</span>
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-center align-items-center my-2">
                            <button
                              type="button"
                              className="btn btn-primary w-100"
                              style={{ fontWeight: 600 }}
                              onClick={openUPIApp}
                            >
                              Pay with UPI App
                            </button>
                          </div>
                        )}
                        <div className="d-flex justify-content-center">
                          <button type="button" className="btn btn-primary w-100" onClick={closeModal}>
                            CLOSE
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn-close position-absolute"
                          aria-label="Close"
                          style={{ top: 12, right: 12, zIndex: 2 }}
                          onClick={closeModal}
                        ></button>
                        <div className="qrpaymentTitel d-flex justify-content-center" style={{ fontSize: 18, textAlign: 'center', marginBottom: 8, fontWeight: 600, marginTop: 24 }}>
                          Can’t open the UPI app? Screenshot the QR and upload it via UPI app to complete the payment.
                        </div>
                        <div className="qrpaymentTitel d-flex justify-content-center" style={{ fontSize: 13, color: '#666', textAlign: 'center', marginBottom: 16 }}>
                          UPI ऐप नहीं खुल रहा है? QR कोड का स्क्रीनशॉट लें और भुगतान पूरा करने के लिए इसे UPI ऐप के माध्यम से अपलोड करें।
                        </div>
                        <div className="d-flex justify-content-center align-items-center my-2" style={{ marginBottom: 20 }}>
                          {qrCodeUrl && (
                            <img src={qrCodeUrl} className="img-fluid" alt="QR Code" style={{ maxWidth: 180, maxHeight: 180, borderRadius: 8, border: '1px solid #eee', background: '#fafafa' }} />
                          )}
                        </div>
                        <div className="d-flex justify-content-center">
                          <button type="button" className="btn btn-primary w-100" style={{ fontWeight: 600 }} onClick={closeModal}>
                            CLOSE
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UpiPayment;
